import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { saveAuthData, saveUserData } from "store/reducers/login/LoginSlice";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import uuid from 'react-uuid';
import ToastModal from "views/components/ToastModal";
import { saveAdminPortalData } from "store/reducers/login/LoginSlice";

const AutoLogin = () => {
  const navigate = useNavigate();
  const { autoId } = useParams();
  const dispatch = useDispatch();

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);

  };

  useEffect(() => {
    autoLogin();
  }, []);
console.log(endpoint.RETAIN_TOKEN + autoId,'endpoint.RETAIN_TOKEN + autoId')
  const autoLogin = async () => {
    const result = await apiHandler({
      url: endpoint.RETAIN_TOKEN + autoId,
    });
    // const tokendata = endpoint.RETAIN_TOKEN + autoId;
    if (result?.data?.error_code) {
      console.log("Error in Auto Login");
    } else {
      // store Login Credentials
      console.log(result,'ajkdhakdhkahkdhkj')
      dispatch(
        saveAuthData({
          authToken: result?.data?.access_token,
          refreshToken: result?.data?.refresh_token,
          tokenTime: Date.now(),
          sessionId: uuid(),
          isAuthenticated: true,
        })
      );
      dispatch(
        saveUserData({
          role: result?.data?.role ? result?.data?.role : "",
          username: result?.data?.username ? result?.data?.username : "",
          email: result?.data?.email ? result?.data?.email : "",
          name: result?.data?.name ? result?.data?.name : "",
          portalUserMobileNumber: result?.data?.mobile_number ? result?.data?.mobile_number : ""
        })
      );
      dispatch(
        saveAdminPortalData({
          enabled: true,
        })
      );
      sessionStorage.setItem('session', uuid());
      navigate("/AdminPortal", { state: { status: "INPROCESS" } });
    }
  };
  return (
    <>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </>
  );
};

export default AutoLogin;

